export const darkTokens = {
  "--bg-deep": "#0F1117",
  "--bg-surface": "#1A1C23",
  "--bg-raised": "#212430",
  "--bg-hover": "#2A2D3A",
  "--bg-active": "#343745",
  "--border-subtle": "rgba(255,255,255,0.06)",
  "--border-mid": "rgba(255,255,255,0.12)",
  "--border-strong": "rgba(255,255,255,0.20)",
  "--text-primary": "#EDEDED",
  "--text-secondary": "rgba(255,255,255,0.7)",
  "--text-tertiary": "rgba(255,255,255,0.5)",
  "--text-muted": "rgba(255,255,255,0.3)",
  "--accent": "#3555AA",
  "--accent-dim": "rgba(53,85,170,0.18)",
  "--accent-glow": "rgba(53,85,170,0.32)",
  "--signal-blue": "#47C5E9",
  "--signal-amber": "#FB923C",
  "--signal-rose": "#FB7185",
  "--signal-violet": "#B5BCFC",
  "--signal-emerald": "#A7C199",
  "--signal-success": "#4FA947",
  "--badge-violet-text": "#B5BCFC",
  "--chart-1": "#3555AA",
  "--chart-2": "#47C5E9",
  "--chart-3": "#B5BCFC",
  "--chart-4": "#FB923C",
  "--chart-5": "#FB7185",
  "--archie-gradient": "linear-gradient(135deg,#6366F1 0%,#8B5CF6 40%,#A78BFA 100%)",
  "--archie-bg": "rgba(99,102,241,0.08)",
  "--archie-border": "rgba(139,92,246,0.25)",
  "--archie-text": "#A78BFA",
} as const;

export const lightTokens = {
  "--bg-deep": "#F2F0EF",
  "--bg-surface": "#FFFFFF",
  "--bg-raised": "#FAFAFA",
  "--bg-hover": "#DDD8D5",
  "--bg-active": "#CFC9C5",
  "--border-subtle": "rgba(0,0,0,0.06)",
  "--border-mid": "rgba(0,0,0,0.12)",
  "--border-strong": "rgba(0,0,0,0.20)",
  "--text-primary": "#212121",
  "--text-secondary": "#666666",
  "--text-tertiary": "rgba(0,0,0,0.5)",
  "--text-muted": "rgba(0,0,0,0.3)",
  "--accent": "#17254A",
  "--accent-dim": "rgba(23,37,74,0.10)",
  "--accent-glow": "rgba(23,37,74,0.18)",
  "--signal-blue": "#0288B5",
  "--signal-amber": "#F97316",
  "--signal-rose": "#E11D48",
  "--signal-violet": "#8f99fb",
  "--signal-emerald": "#88AB75",
  "--signal-success": "#4FA947",
  "--badge-violet-text": "#3F4FCC",
  "--chart-1": "#17254A",
  "--chart-2": "#0288B5",
  "--chart-3": "#8f99fb",
  "--chart-4": "#F97316",
  "--chart-5": "#E11D48",
  "--archie-gradient": "linear-gradient(135deg,#6366F1 0%,#8B5CF6 40%,#A78BFA 100%)",
  "--archie-bg": "rgba(99,102,241,0.06)",
  "--archie-border": "rgba(139,92,246,0.2)",
  "--archie-text": "#7C3AED",
} as const;

export type V2TokenMap = typeof darkTokens;

export const FONT_SANS = "'DM Sans', -apple-system, sans-serif";
export const FONT_DISPLAY = "'Fraunces', Georgia, serif";
export const FONT_MONO = "'JetBrains Mono', monospace";

export const RAIL_WIDTH_COLLAPSED = 64;
export const RAIL_WIDTH_EXPANDED = 210;
export const DETAIL_PANE_WIDTH = 480;
export const ARCHIE_PANEL_WIDTH = 380;
